import { Button, Card } from "antd";
import styled from "styled-components";

export const ArticleCard = styled(Card)`
    border-color: transparent;
      box-shadow: 0px 4px 10px rgb(0 0 0 / 3%);
/* width: 33%; */
  height: 330px;
border-radius: 15px;
.ant-card-body{
  padding: 8px 18px;
}
.ant-card-cover img{
  border-radius: 15px 15px 0px 0px;
  width: 100%;
  height: 250px;
}
    p{
      margin:0;
       color: #121111;
       font-size:14px;
       font-weight:600;
    }
    div.description{
      display: flex;
      flex-direction:column;
      p{
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }
    div.views{
      gap:6px;
      display: flex;
      align-content: flex-start;
    justify-content: flex-start;
    align-items: center;
    color: #A3A9BF;
    font-size:12px;
    margin-top: 8px;
      @media only screen and (max-width: 354px) {
        font-size:10px;
      }
      @media only screen and (max-width: 323px) {
        font-size:9px;
      }
      @media only screen and (max-width: 303px) {
        font-size:8px;
        gap:3px;
      }
      @media only screen and (max-width: 1266px) and (min-width: 1200px){
        font-size:10px;
        gap:3px;
      }
    }
`;